import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import LegalNav from "./LegalNav";
import "./legal.css";

export default function LegalPage({ title, lastUpdated, children }) {
  return (
    <div>
      <Header />
      <Box sx={{ backgroundColor: "#fff", pt: { xs: 6, md: 8 }, pb: 8 }}>
        <Container maxWidth="md">
          <Typography
            sx={{
              fontWeight: 700,
              color: "#000",
              mb: 1,
              fontSize: { xs: "1.8rem", md: "2.4rem" },
            }}
          >
            {title}
          </Typography>
          {lastUpdated && (
            <Typography sx={{ color: "#777", mb: 3, fontSize: "0.95rem" }}>
              Last updated: {lastUpdated}
            </Typography>
          )}
          <LegalNav />
          <Box className="legal-content" mt={4}>
            {children}
          </Box>
        </Container>
      </Box>
      <Footer />
    </div>
  );
}
